import { Stack, Text } from '@mantine/core';
import { useCalendars } from 'src/meetings/hooks/useCalendars';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import PageLoader from 'src/UI/loader/PageLoader';
import { ConnectedCalendarAccountCard } from 'src/meetings/components/ConnectedCalendarAccountCard';

type Props = {
  filter?: 'CONNECTED' | 'DISCONNECTED';
};

export const CalendarsListComponent = ({ filter = 'CONNECTED' }: Props) => {
  const {
    connectedCalendars,
    disconnectedCalendars,
    isLoading: isLoadingCalendar,
    refetch,
  } = useCalendars();

  const calendars = filter === 'CONNECTED' ? connectedCalendars : disconnectedCalendars;
  const title = filter === 'CONNECTED' ? 'Connected calendars' : 'Disconnected calendars';

  if (calendars.length === 0 && !isLoadingCalendar) {
    return null;
  }

  return (
    <Stack gap="xs">
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10">
        {title}
      </Text>
      {isLoadingCalendar ? (
        <PageLoader absolute={false} />
      ) : (
        calendars.map(calendar => (
          <ConnectedCalendarAccountCard
            key={calendar.id}
            calendar={calendar}
            onDisconnected={refetch}
          />
        ))
      )}
    </Stack>
  );
};
